import React from 'react';

const DayItem = (props) => {
    return (
        <div class="box box-schDay m-b-5" onClick={() => props.selectDay(props.item.dayName)} data-target-day="Saturday">
            <div class="box-body">

                <div class="row m-t-5 m-r-5 m-l-5">
                    <div class="col-3">
                        <div class="day">{props.item.dayName}</div>
                        <div class="date text-nowrap">{props.item.date}</div>

                    </div>
                    <div class="col-5">
                        <div class="notes">
                        </div>

                    </div>
                    <div class="col-2 text-center">
                        <span class="timelbl">Time From </span><br />
                        <span class="time">{props.item.timeFrom}</span>
                    </div>
                    <div class="col-2  text-center">
                        <span class="timelbl">Time To </span><br />
                        <span class="time">{props.item.timeTo}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <table class="schedule-dayoverview">
                            <tbody><tr>

                                {props.item.items.map((i) => <td className={i.isActive? 'active':''}>{i.slotID}</td>)}

                            

                            </tr>
                            </tbody></table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DayItem;


// WEBPACK FOOTER //
// ./src/pages/student_schedule/DayItem.js